import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { TableContainer, TablePagination } from "@mui/material";
import { SearchInput, CustomButton } from "../../../../common/components";
import styles from "./DashPortfolio.module.css";
import { CompanyType, environmentSwitch, isCompanyTypeAllowed, translate } from "../../../../common/providers";
import { debounce } from "../../../../common/utils";
import DashPortfolioTable from "./dash-portfolio-table/DashPortfolioTable";
import ProjectCreationModal from "../../dashboard-portfolio/portfolio-user/components/project-creation/ProjectCreationModal";
import { ProjectCreationService } from "../../../../api";
import { useApi } from "../../../../common/hooks";
import { setProjectCreation } from "../../../new-project/slice/newProjectSlice";

const debounceFunc = debounce((func) => func(), 200);
export default function DashPortfolio({
	isAdminOrManager,
	onCaptureNewProject,
	onChangeCompany,
	onChangePage,
	onChangeRowsPerPage,
	onChangeTeam,
	onSetSearch,
	onJoinProject,
	onOpenSidePanel,
	onSelectProject,
	onSetIndex,
	page,
	projects,
	rowsPerPage,
	selectedRow,
	selectedTeams,
	onClickSort,
	sortDirection,
	sortKey,
	setCurrentProjectsPage,
}) {
	const [search, setSearch] = useState("");
	const [openProjCreationSP, setOpenProjCreationSP] = useState(false);
	const { call: createProject } = useApi(ProjectCreationService.createProject);
	const { call: getOngoingProject } = useApi(ProjectCreationService.getOngoingProject);
	const { call: abortProjectCreation } = useApi(ProjectCreationService.abortProjectCreation);
	const dispatch = useDispatch();
	const handleChangeSearchValue = (e) => {
		const { value } = e.target;
		setSearch(value);
		setCurrentProjectsPage(0);
		debounceFunc(() => {
			onSetSearch(value);
		});
	};
	const handleClearSearchValue = () => {
		setSearch("");
		debounceFunc(() => {
			onSetSearch("");
		});
	};
	const handleCreateProject = () => {
		createProject()
			.then((data) => {
				dispatch(setProjectCreation({ project: data }));
				onCaptureNewProject();
			})
			.catch((err) => console.error(err));
	};
	const handleOpenSP = () => {
		setOpenProjCreationSP(true);
		getOngoingProject()
			.then((data) => {
				if (data?.project?.id) {
					abortProjectCreation({ projectId: data.project.id })
						.then(() => {
							handleCreateProject();
						})
						.catch(console.error);
				} else {
					handleCreateProject();
				}
			})
			.catch(console.error);
	};
	const handleCloseSP = () => setOpenProjCreationSP(false);
	return (
		<div className={styles.container}>
			<div className={styles.newProjectButtonContainer}>
				<div>
					<SearchInput
						className={styles.searchContainer__textfield}
						label={translate("dashboards.dash-portfolio.textfield.search.label")}
						value={search}
						onChange={handleChangeSearchValue}
						onClearSearch={handleClearSearchValue}
					/>
				</div>
				{environmentSwitch({
					main: isAdminOrManager,
					veolia: isAdminOrManager,
					smac: true,
				}) &&
					isCompanyTypeAllowed([CompanyType.BUSINESS_UNIT, CompanyType.COMPANY]) && (
						<div id="tour-dashboard-new-project-button">
							<CustomButton
								buttonClassName={styles.newProjectButtonContainer__button}
								color="primary"
								data-testid="portfolio.newProjectBtn"
								size="md"
								variant="outlined"
								onClick={handleOpenSP}
							>
								{translate("dashboards.dash-portfolio.button.new-project")}
							</CustomButton>
						</div>
					)}
			</div>
			<div className={styles.superTableContainer} id="tour-project-list-project-table">
				<TableContainer className={styles.tableContainer}>
					<DashPortfolioTable
						projectList={projects.contents}
						selectedRow={selectedRow}
						selectedTeams={selectedTeams}
						sortDirection={sortDirection}
						sortKey={sortKey}
						onChangeCompany={onChangeCompany}
						onChangeTeam={onChangeTeam}
						onClickSort={onClickSort}
						onJoinProject={onJoinProject}
						onOpenSidePanel={onOpenSidePanel}
						onSelectRow={onSelectProject}
						onSetIndex={onSetIndex}
					/>
				</TableContainer>
				<TablePagination
					component="div"
					count={projects.totalElements}
					page={page}
					rowsPerPage={rowsPerPage}
					rowsPerPageOptions={[50, 100, 200]}
					onPageChange={onChangePage}
					onRowsPerPageChange={onChangeRowsPerPage}
				/>
			</div>
			<ProjectCreationModal open={openProjCreationSP} onClose={handleCloseSP} />
		</div>
	);
}
